let locales = {
    rolesEdit_title: 'Crear Rol',
    rolesEdit_titleEdit: 'Editar Rol',
};

export default locales;